import Shuffle from 'shufflejs';

const galleryGrid = document.getElementById('gallery-grid');
const sortSelect = document.getElementById('gallery-sort-form');
const catalogueSelect = document.getElementById('gallery-catalogue-form');
const lightbox = document.querySelector('.lightbox');
const lightboxImageContainer = document.getElementById('lightbox-image-container');

const previousImageButton = document.getElementById('previous-image-button');
const imageVersionButton = document.getElementById('image-version-button');
const nextImageButton = document.getElementById('next-image-button');

const imageElement = document.getElementById('lightbox-image');
const originalImageElement = document.getElementById('lightbox-original-image');

const lightboxCloseButton = document.getElementById('lightbox-close-button');
function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('visible');
    lightboxImageIndex = null;
    lightboxImageVersion = null;
}
lightboxCloseButton.addEventListener('click', closeLightbox);
if (typeof window !== 'undefined') {
    window.closeGalleryLightbox = closeLightbox;
}

let lightboxQuestion = document.getElementById('lightbox-question');
let lightboxAnswer = document.getElementById('lightbox-answer');
let lightboxCueCard = document.getElementById('lightbox-cue-card');
let lightboxLikes = document.getElementById('lightbox-likes');
let lightboxCommentInput = document.getElementById('lightbox-comment-input');
let lightboxCommentSubmit = document.getElementById('lightbox-comment-submit');
let lightboxCommentStatus = document.getElementById('lightbox-comment-status');
let lightboxParticipateButton = document.getElementById('lightbox-participate-button');

const loadingScreen = document.getElementById('loading-screen');

let imageData = [];
let shuffleInstance = null;

let currentSort = sortSelect.value;
let currentCatalogue = catalogueSelect.value;

let likedImageIds = new Set();

function ensureLightboxElements() {
    if (!lightboxQuestion) lightboxQuestion = document.getElementById('lightbox-question');
    if (!lightboxAnswer) lightboxAnswer = document.getElementById('lightbox-answer');
    if (!lightboxCueCard) lightboxCueCard = document.getElementById('lightbox-cue-card');
    if (!lightboxLikes) lightboxLikes = document.getElementById('lightbox-likes');
    if (!lightboxCommentInput) lightboxCommentInput = document.getElementById('lightbox-comment-input');
    if (!lightboxCommentSubmit) lightboxCommentSubmit = document.getElementById('lightbox-comment-submit');
    if (!lightboxCommentStatus) lightboxCommentStatus = document.getElementById('lightbox-comment-status');
    if (!lightboxParticipateButton) lightboxParticipateButton = document.getElementById('lightbox-participate-button');

    if (lightboxLikes && !lightboxLikes.dataset.bound) {
        lightboxLikes.addEventListener('click', (event) => {
            event.stopPropagation();
            if (lightboxImageIndex === null || !imageData[lightboxImageIndex]) return;
            likeClicked(imageData[lightboxImageIndex].id);
        });
        lightboxLikes.dataset.bound = 'true';
    }

    if (lightboxCommentSubmit && !lightboxCommentSubmit.dataset.bound) {
        lightboxCommentSubmit.addEventListener('click', submitComment);
        lightboxCommentSubmit.dataset.bound = 'true';
    }

    if (lightboxParticipateButton && !lightboxParticipateButton.dataset.bound) {
        lightboxParticipateButton.addEventListener('click', (event) => {
            event.stopPropagation();
            launchParticipationForCurrentImage();
        });
        lightboxParticipateButton.dataset.bound = 'true';
    }
}

const fallbackLocationMeta = {
    1: {
        title: 'Plek van Havenloods',
        questions: ['Sfeer', 'Havenloods', 'Deze plek is bedoelt voor...']
    },
    2: {
        title: 'Eemskanaal',
        questions: ['Sfeer', 'De kade is bedoelt voor...', 'Het water is bedoelt voor..']
    },
    3: {
        title: 'Deense Haven',
        questions: ['Sfeer', 'De kade is bedoelt voor...', 'Het water is bedoelt voor..']
    }
};

const PROJECT_CODE = 'HGS2';

function normalizeLocationId(value) {
    const direct = Number(value);
    if (Number.isFinite(direct) && direct > 0) return direct;
    const extracted = parseInt(String(value || '').replace(/\D+/g, ''), 10);
    return Number.isFinite(extracted) && extracted > 0 ? extracted : 0;
}

function getLocationMeta(questionId) {
    const locId = normalizeLocationId(questionId);
    const points = Array.isArray(window.participationPoints) ? window.participationPoints : [];
    const point = points.find(p => Number(p.no) === locId);
    if (point) {
        return {
            title: point.title || point.name || fallbackLocationMeta[locId]?.title || 'Locatie',
            questions: [
                point.Question1?.name,
                point.Question2?.name,
                point.Question3?.name
            ]
        };
    }
    return fallbackLocationMeta[locId] || { title: 'Locatie', questions: [] };
}

function getLocationTitle(questionId) {
    return getLocationMeta(questionId).title;
}

function getOrCreateUserId() {
    let uid = sessionStorage.getItem('userID') || localStorage.getItem('userUID') || '';
    if (!uid) {
        const code = Math.floor(10000000 + Math.random() * 90000000).toString();
        uid = `${PROJECT_CODE}${code}`;
        sessionStorage.setItem('userID', uid);
    }
    localStorage.setItem('userUID', uid);
    return uid;
}

async function getUserIp() {
    let ip = localStorage.getItem('userIP') || '';
    if (ip) return ip;

    try {
        const response = await fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php');
        const data = await response.json();
        ip = data.ip || '';
        if (ip) {
            localStorage.setItem('userIP', ip);
        }
    } catch (_err) {
        ip = '';
    }

    return ip;
}

export async function resolveUserIdentity() {
    const uid = getOrCreateUserId();
    const ip = await getUserIp();
    return { uid, ip };
}

function parseAnswerArray(value) {
    if (value == null) return [];
    if (Array.isArray(value)) {
        return value.map(String).filter(v => v.trim() !== '' && v !== '-');
    }

    const raw = String(value).trim();
    if (!raw || raw === '-') return [];

    if (raw.startsWith('[') && raw.endsWith(']')) {
        try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
                return parsed.map(String).filter(v => v.trim() !== '' && v !== '-');
            }
            if (parsed != null) return [String(parsed)];
        } catch (_err) {
            // fall through
        }
    }

    let cleaned = raw;
    if (cleaned.startsWith('[') && cleaned.endsWith(']')) {
        cleaned = cleaned.slice(1, -1);
    }
    cleaned = cleaned.trim();
    if (!cleaned) return [];

    if (cleaned.includes(',')) {
        return cleaned
            .split(',')
            .map(part => part.trim().replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, ''))
            .filter(part => part !== '' && part !== '-');
    }

    const single = cleaned.replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, '').trim();
    return single && single !== '-' ? [single] : [];
}

function escapeHTML(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function buildAnswerSummary(image) {
    const locationValue = image.question_id ?? image.questionId ?? image.location_id ?? image.locationId ?? 0;
    const meta = getLocationMeta(locationValue);
    const questionLabels = meta.questions.length ? meta.questions : ['Vraag 1', 'Vraag 2', 'Vraag 3'];
    const answers = [
        parseAnswerArray(image.question1_answers),
        parseAnswerArray(image.question2_answers),
        parseAnswerArray(image.question3_answers)
    ];

    const parts = answers.map((list, idx) => {
        if (!list.length) return null;
        const label = questionLabels[idx] || `Vraag ${idx + 1}`;
        return `<strong>${escapeHTML(label)}</strong>: ${escapeHTML(list.join(', '))}`;
    }).filter(Boolean);

    return parts.length ? parts.join('<br>') : 'geen antwoorden';
}

function buildAdditionalText(image) {
    const text = String(image.additional_text || '').trim();
    if (!text || text === '-') return 'geen extra prompt';
    return text;
}

function showLoadingScreen() {
    loadingScreen.classList.remove('hidden');
    galleryGrid.classList.add('hidden');
}

function hideLoadingScreen() {
    loadingScreen.classList.add('hidden');
    galleryGrid.classList.remove('hidden');
    if (shuffleInstance) {
        shuffleInstance.update();
    }
}

async function updateLikesOnServer(imageId) {
    const { ip, uid } = await resolveUserIdentity();
    if (!ip || !uid) {
        console.warn('Missing user identity for like.');
        return null;
    }

    return fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Like_Gallery_Image.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            image_id: imageId,
            user_ip: ip,
            user_uid: uid
        })
    })
        .then(response => response.json())
        .catch(error => {
            console.error('Error updating like on server:', error);
            return null;
        });
}

// Load from sessionStorage
function loadLikedImages() {
    const raw = sessionStorage.getItem('likedImageIds');
    if (raw) {
        likedImageIds = new Set(JSON.parse(raw));
    }
}

loadLikedImages();

// Save to sessionStorage
function saveLikedImages() {
    sessionStorage.setItem('likedImageIds', JSON.stringify([...likedImageIds]));
}

function setCommentStatus(message) {
    if (!lightboxCommentStatus) return;
    lightboxCommentStatus.textContent = message;
}

function submitComment() {
    ensureLightboxElements();
    if (lightboxImageIndex === null || !imageData[lightboxImageIndex]) {
        setCommentStatus('Selecteer eerst een afbeelding.');
        return;
    }
    if (!lightboxCommentInput || !lightboxCommentSubmit) return;

    const commentText = lightboxCommentInput.value.trim();
    if (!commentText) {
        setCommentStatus('Vul eerst een reactie in.');
        return;
    }

    const age_group = sessionStorage.getItem('userAge') || window.sessionUserAge || '-';
    const relation_to_place = sessionStorage.getItem('userRelation') || window.sessionUserRelation || '-';
    const gender = sessionStorage.getItem('userGender') || window.sessionUserGender || '-';
    const activeImageId = Number(
        imageData[lightboxImageIndex]?.id || imageData[lightboxImageIndex]?.image_id || 0
    );
    if (!activeImageId) {
        setCommentStatus('Kon afbeelding niet bepalen.');
        return;
    }

    lightboxCommentSubmit.disabled = true;
    setCommentStatus('Reactie wordt opgeslagen...');

    resolveUserIdentity()
        .then(({ ip, uid }) => {
            if (!ip || !uid) {
                setCommentStatus('Kan reactie niet opslaan zonder gebruiker.');
                throw new Error('missing identity');
            }
            return fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/ImageComment_Insert.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    image_id: activeImageId,
                    comment_text: commentText,
                    user_ip: ip,
                    user_uid: uid,
                    age_group,
                    relation_to_place,
                    gender
                })
            });
        })
        .then(response => response.json())
        .then(data => {
            if (data && data.status === 'ok') {
                lightboxCommentInput.value = '';
                setCommentStatus('Reactie opgeslagen!');
                return;
            }
            setCommentStatus('Kon reactie niet opslaan.');
        })
        .catch(() => {
            if (lightboxCommentStatus.textContent === 'Kan reactie niet opslaan zonder gebruiker.') {
                return;
            }
            setCommentStatus('Netwerkfout bij opslaan.');
        })
        .finally(() => {
            lightboxCommentSubmit.disabled = false;
        });
}


sortSelect.addEventListener('change', (e) => {
    currentSort = e.target.value;
    sortImages();
});

function sortImages() {
    if (currentSort === 'new-to-old') {
        shuffleInstance.sort({ by: el => new Date(el.dataset.generated_at), reverse: true });
        return;
    }
    if (currentSort === 'old-to-new') {
        shuffleInstance.sort({ by: el => new Date(el.dataset.generated_at) });
        return;
    }
    if (currentSort === 'most-liked') {
        shuffleInstance.sort({ by: el => parseInt(el.dataset.likes, 10), reverse: true });
        return;
    }
    if (currentSort === 'least-liked') {
        shuffleInstance.sort({ by: el => parseInt(el.dataset.likes, 10) });
        return;
    }
}

function filterCatalogue() {
    if (currentCatalogue === 'all-places') {
        // show all
        shuffleInstance.filter();
        return;
    }
    const targetId = normalizeLocationId(currentCatalogue);
    shuffleInstance.filter(el => normalizeLocationId(el.dataset.question_id) === targetId);
}

catalogueSelect.addEventListener('change', (e) => {
    currentCatalogue = e.target.value;
    filterCatalogue();
});

function likeClicked(imageId) {
    const item = imageData.find(img => img.id === imageId);
    if (!item) return;

    const div = item.domElement;
    const likes = div.querySelector('.likes-count');
    updateLikesOnServer(imageId).then(data => {
        if (!data || !data.success) return;

        if (data.liked) {
            likedImageIds.add(imageId);
        } else {
            likedImageIds.delete(imageId);
        }

        if (typeof data.new_like_count === 'number') {
            item.number_of_likes = data.new_like_count;
        }

        likes.textContent = `❤️ ${item.number_of_likes}`;
        div.dataset.likes = item.number_of_likes;
        if (lightboxImageIndex !== null && imageData[lightboxImageIndex]?.id === imageId) {
            if (lightboxLikes) {
                lightboxLikes.textContent = `❤️ ${item.number_of_likes}`;
            }
        }
        saveLikedImages();
    });
}

export function fetchGalleryImages() {
    resolveUserIdentity().then(({ ip, uid }) => {
        const url = `https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Get_Gallery_Images.php` +
            `?ip=${encodeURIComponent(ip)}&uid=${encodeURIComponent(uid)}`;

        return fetch(url);
    })
        .then(response => response.json())
        .then(data => {
            const notYetGeneratedCount = data.filter(img => !img.generated_image || img.generated_image.trim() === '-').length;

            if (notYetGeneratedCount > 0) {
                setTimeout(fetchGalleryImages, 5000);
            }

            const newImageData = data.filter(img => img.generated_image && img.generated_image.trim() !== '-');

            const needsFieldRefresh = imageData.some(img => img.question1_answers === undefined);
            const sameIds = imageData.length === newImageData.length &&
                imageData.every((img, idx) => img.id === newImageData[idx]?.id);

            if (!sameIds || needsFieldRefresh || imageData.length !== newImageData.length) {
                imageData = newImageData;
                renderGallery();
            }
        })
        .catch(error => {
            console.error('Error fetching gallery images:', error);
        });
}

function nextImage() {
    const sortedItems = shuffleInstance.sortedItems;
    const currentSortedIndex = sortedItems.findIndex(item => {
        const el = item.element;
        return parseInt(el.dataset.id, 10) === imageData[lightboxImageIndex].id;
    });
    if (currentSortedIndex === -1 || currentSortedIndex === sortedItems.length - 1) return;
    const nextEl = sortedItems[currentSortedIndex + 1].element;
    const nextId = parseInt(nextEl.dataset.id, 10);
    const nextIndex = imageData.findIndex(img => img.id === nextId);

    if (nextIndex === -1) return;

    openImage(nextIndex);
}

function previousImage() {
    const sortedItems = shuffleInstance.sortedItems;
    const currentSortedIndex = sortedItems.findIndex(item => {
        const el = item.element;
        return parseInt(el.dataset.id, 10) === imageData[lightboxImageIndex].id;
    });
    if (currentSortedIndex <= 0) return;
    const prevEl = sortedItems[currentSortedIndex - 1].element;
    const prevId = parseInt(prevEl.dataset.id, 10);
    const prevIndex = imageData.findIndex(img => img.id === prevId);

    if (prevIndex === -1) return;

    openImage(prevIndex);
}

// The index of the currently displayed image in the lightbox (in the imageData array)
let lightboxImageIndex = null;
let lightboxImageVersion = null;

function openImage(imageIndex, version = 'generated') {
    ensureLightboxElements();
    const image = imageData[imageIndex];
    if (!image) return;
    const locationValue = image.question_id ?? image.questionId ?? image.location_id ?? image.locationId ?? 0;
    const locationId = normalizeLocationId(locationValue);

    lightboxImageIndex = imageIndex;
    lightboxImageVersion = version;

    lightbox.classList.add('visible');

    imageElement.src = image.generated_image;
    imageElement.onclick = (event) => {
        event.stopPropagation();
        likeClicked(image.id);
    };

    if (lightboxLikes) {
        lightboxLikes.textContent = `❤️ ${image.number_of_likes}`;
    }
    originalImageElement.src = image.original_image;

    if (version !== 'generated') {
        imageElement.classList.add('transparent');
        if (lightboxLikes) {
            lightboxLikes.classList.add('transparent');
        }
        originalImageElement.classList.remove('transparent');
    } else {
        imageElement.classList.remove('transparent');
        if (lightboxLikes) {
            lightboxLikes.classList.remove('transparent');
        }
        originalImageElement.classList.add('transparent');
    }

    if (imageVersionButton) {
        imageVersionButton.textContent = version === 'original' ? 'bekijk gegenereerd' : 'bekijk origineel';
    }

    if (previousImageButton) previousImageButton.style.visibility = 'visible';
    if (nextImageButton) nextImageButton.style.visibility = 'visible';

    const sortedIndex = shuffleInstance && shuffleInstance.sortedItems
        ? shuffleInstance.sortedItems.findIndex(item => {
            const el = item.element;
            return parseInt(el.dataset.id, 10) === image.id;
        })
        : -1;

    // Hide buttons if at the ends
    if (!shuffleInstance || !shuffleInstance.sortedItems || sortedIndex === -1) {
        if (nextImageButton) nextImageButton.style.visibility = 'hidden';
        if (previousImageButton) previousImageButton.style.visibility = 'hidden';
    } else {
        if (sortedIndex === shuffleInstance.sortedItems.length - 1 && nextImageButton) {
            nextImageButton.style.visibility = 'hidden';
        }
        if (sortedIndex <= 0 && previousImageButton) {
            previousImageButton.style.visibility = 'hidden';
        }
    }

    // Update answer and cue card
    if (lightboxQuestion) {
        lightboxQuestion.textContent = getLocationTitle(locationValue);
    }
    if (lightboxAnswer) {
        lightboxAnswer.innerHTML = buildAnswerSummary(image);
    }
    if (lightboxCueCard) {
        lightboxCueCard.textContent = buildAdditionalText(image);
    }

    if (lightboxParticipateButton) {
        lightboxParticipateButton.dataset.locationId = locationId ? String(locationId) : '';
        lightboxParticipateButton.disabled = !locationId;
    }

    if (lightboxCommentInput) lightboxCommentInput.value = '';
    if (lightboxCommentStatus) lightboxCommentStatus.textContent = '';
    if (lightboxCommentSubmit) lightboxCommentSubmit.disabled = false;
}

function launchParticipationForCurrentImage() {
    if (lightboxImageIndex === null || !imageData[lightboxImageIndex]) return;
    const image = imageData[lightboxImageIndex];
    const locationValue = image.question_id ?? image.questionId ?? image.location_id ?? image.locationId ?? 0;
    const locationId = normalizeLocationId(locationValue);
    if (!locationId) return;

    if (typeof window.launchParticipationForLocation === 'function') {
        window.launchParticipationForLocation(locationId);
        return;
    }
    if (typeof window.launchRandomParticipation === 'function') {
        window.launchRandomParticipation();
    } else {
        console.warn('No participation launcher available.');
    }
}

previousImageButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (lightboxImageIndex === null) return;
    previousImage();
});

nextImageButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (lightboxImageIndex === null) return;
    nextImage();
});

imageVersionButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (lightboxImageIndex === null) return;

    let version;

    if (lightboxImageVersion === 'original') {
        version = 'generated';
    } else {
        version = 'original';
    }

    openImage(lightboxImageIndex, version);
});

function renderGallery() {
    console.log('Rendering gallery with data:', imageData);
    // Clear grid
    galleryGrid.innerHTML = '';

    const totalImages = imageData.length;
    let loadedImages = 0;
    let loadingFinished = false;

    const markLoaded = () => {
        loadedImages += 1;
        if (loadingFinished) return;
        if (loadedImages >= totalImages) {
            loadingFinished = true;
            hideLoadingScreen();
        }
    };

    if (totalImages === 0) {
        hideLoadingScreen();
    } else showLoadingScreen();

    // Create items
    imageData.forEach(item => {
        const div = document.createElement('div');
        div.classList.add('gallery-item');
        div.dataset.id = item.id;
        const locationId = normalizeLocationId(item.question_id ?? item.questionId ?? item.location_id ?? item.locationId);
        div.dataset.question_id = locationId;
        div.dataset.generated_at = item.generated_at;
        div.dataset.likes = item.number_of_likes;

        div.addEventListener('click', (event) => {
            event.stopPropagation();
            const index = imageData.findIndex(img => img.id === item.id);
            if (index !== -1) {
                openImage(index);
            }
        });

        const img = document.createElement('img');
        let imgSettled = false;
        const markLoadedOnce = () => {
            if (imgSettled) return;
            imgSettled = true;
            markLoaded();
        };
        img.onload = () => {
            markLoadedOnce();
        };
        img.onerror = () => {
            markLoadedOnce();
        };
        img.src = item.generated_image;
        img.alt = `Image ${item.id}`;
        if (img.complete) {
            setTimeout(markLoadedOnce, 0);
        }

        const likes = document.createElement('div');
        likes.classList.add('likes-count');
        likes.textContent = `❤️ ${item.number_of_likes}`;
        likes.addEventListener('click', (event) => {
            event.stopPropagation();
            likeClicked(item.id);
        });

        div.appendChild(img);
        div.appendChild(likes);

        galleryGrid.appendChild(div);

        item.domElement = div; // Store reference for later use
    });

    // Initialize Shuffle if not already
    if (!shuffleInstance) {
        shuffleInstance = new Shuffle(galleryGrid, {
            itemSelector: '.gallery-item',
            sizer: '.gallery-sizer',
        });
    } else {
        shuffleInstance.resetItems();
    }

    // Initial filtering and sorting
    filterCatalogue();
    sortImages();
}

// Don't fetch gallery images in Havenpark
// fetchGalleryImages();
